import { processorGamecashDeposit, optionGamecashDeposit, processGamecashDeposit, processPixDeposit } from '@/utils/api';
import Vue from 'vue';
import Vuex from 'vuex';
import { getField, updateField } from 'vuex-map-fields';
import i18n from '@/utils/i18n';

Vue.use(Vuex);

const getDefaultState = () => {
  return {
    depositStatus: {
      loading: false,
      success: false,
      error: false,
      redirect: false,
    },
    allProcessors: [],
    allOptionsLoading: false,
    allOptions: [],
    currentProcessor: {},
  };
};
const state = getDefaultState();

const getters = {
  getField,
};
const mutations = {
  updateField,
  setAllProcessors(state, allProcessors) {
    state.allProcessors = allProcessors;
  },
  setAllOptionsLoading(state, allOptionsLoading) {
    state.allOptionsLoading = allOptionsLoading;
  },
  setAllOptions(state, allOptions) {
    state.allOptions = allOptions;
  },
  setCurrentProcessor(state, currentProcessor) {
    state.currentProcessor = currentProcessor;
  },
  setDepositStatus(state, row) {
    state.depositStatus = {
      ...state.depositStatus,
      ...row,
    };
  },
};

const actions = {
  tryGetProcessors({ commit }) {
    commit('setAllProcessors', []);
    commit('setAllOptionsLoading', true);

    processorGamecashDeposit()
      .then(r => {
        if (r.data.IsSuccess) {
          let processors = r.data.Data;
          let all4Pay = processors.filter(item => item.code === 'AL_BO');
          processors = all4Pay.length ? all4Pay : processors;
          commit('setAllProcessors', processors);
        }
      })
      .finally(() => {
        commit('setAllOptionsLoading', false);
      });
  },
  tryGetOptions({ commit }, currentProcessor) {
    commit('setAllOptions', []);
    commit('setAllOptionsLoading', true);
    commit('setCurrentProcessor', currentProcessor);
    optionGamecashDeposit(currentProcessor)
      .then(r => {
        if (r.data.IsSuccess) {
          const options = r.data.Data;
          commit('setAllOptions', options);
        } else {
          commit('setAllOptions', []);
        }
      })
      .catch(() => {
        commit('setAllOptions', []);
      })
      .finally(() => {
        commit('setAllOptionsLoading', false);
      });
  },
  tryDeposit({ commit, dispatch }, payload) {
    Vue.prototype.$gtmProvider.sendDepositEvent(
      {
        eventLabel: 'cash_attempt',
        eventValue: Vue.prototype.$gaHelper.getDepositValue(payload.amount),
      },
      {
        label: 'cash_attempt',
        value: Vue.prototype.$gaHelper.getDepositValue(payload.amount),
      },
    );
    commit('setDepositStatus', {
      loading: true,
      success: false,
      error: false,
      redirect: false,
    });
    commit('depositStore/setPostDepositLoading', true, { root: true });
    processGamecashDeposit(payload)
      .then(r => {
        if (r.data.IsSuccess && r.data.Data.success) {
          Vue.prototype.$gtmProvider.sendDepositEvent(
            {
              eventLabel: 'cash_success',
              eventValue: Vue.prototype.$gaHelper.getDepositValue(payload.amount),
            },
            {
              label: 'cash_success',
              value: Vue.prototype.$gaHelper.getDepositValue(payload.amount),
            },
          );
          dispatch('player/tryGetBalance', null, { root: true });
          if (payload.option.code === 'AL_BO' && r.data.Data.redirectUrl) {
            window.location.href = r.data.Data.redirectUrl;
          }
          commit('setDepositStatus', {
            error: false,
            success: i18n.t('DepositView.GameCash.SuccessMessage'),
            receipt: r.data.Data,
          });
        } else {
          let errorMessage = r.data.IsSuccess ? r.data.Data.message : r.data.ExceptionMessage[0];
          commit('setDepositStatus', {
            error: i18n.t('DepositView.GameCash.Error.' + errorMessage),
            success: false,
            redirect: false,
          });
          Vue.prototype.$gtmProvider.sendDepositEvent(
            {
              eventLabel: 'cash_fail',
              eventValue: Vue.prototype.$gaHelper.getDepositValue(payload.amount),
            },
            {
              label: 'cash_fail',
              value: Vue.prototype.$gaHelper.getDepositValue(payload.amount),
            },
          );
        }
      })
      .catch(() => {
        Vue.prototype.$gtmProvider.sendDepositEvent(
          {
            eventLabel: 'cash_fail',
            eventValue: Vue.prototype.$gaHelper.getDepositValue(payload.amount),
          },
          {
            label: 'cash_fail',
            value: Vue.prototype.$gaHelper.getDepositValue(payload.amount),
          },
        );
      })
      .finally(() => {
        commit('depositStore/setPostDepositLoading', false, { root: true });
      });
  },
  tryPixDeposit({ commit, dispatch }, payload) {
    Vue.prototype.$gtmProvider.sendDepositEvent(
        {
          eventLabel: 'cash_attempt',
          eventValue: Vue.prototype.$gaHelper.getDepositValue(payload.amount),
        },
        {
          label: 'cash_attempt',
          value: Vue.prototype.$gaHelper.getDepositValue(payload.amount),
        },
    );
    commit('setDepositStatus', {
      loading: true,
      success: false,
      error: false,
      redirect: false,
    });
    commit('depositStore/setPostDepositLoading', true, { root: true });
    processPixDeposit(payload.userDocument, payload.amount)
        .then(r => {
          if (r.data.IsSuccess && r.data.Data.success) {
            Vue.prototype.$gtmProvider.sendDepositEvent(
                {
                  eventLabel: 'cash_success',
                  eventValue: Vue.prototype.$gaHelper.getDepositValue(payload.amount),
                },
                {
                  label: 'cash_success',
                  value: Vue.prototype.$gaHelper.getDepositValue(payload.amount),
                },
            );
            dispatch('player/tryGetBalance', null, { root: true });
            commit('setDepositStatus', {
              error: false,
              success: i18n.t('DepositView.GameCash.SuccessMessage'),
              receipt: r.data.Data,
            });
          } else {
            let errorMessage = r.data.IsSuccess ? r.data.Data.message : r.data.ExceptionMessage[0];
            commit('setDepositStatus', {
              error: i18n.t('DepositView.GameCash.Error.' + errorMessage),
              success: false,
              redirect: false,
            });
            Vue.prototype.$gtmProvider.sendDepositEvent(
                {
                  eventLabel: 'cash_fail',
                  eventValue: Vue.prototype.$gaHelper.getDepositValue(payload.amount),
                },
                {
                  label: 'cash_fail',
                  value: Vue.prototype.$gaHelper.getDepositValue(payload.amount),
                },
            );
          }
        })
        .catch(() => {
          Vue.prototype.$gtmProvider.sendDepositEvent(
              {
                eventLabel: 'cash_fail',
                eventValue: Vue.prototype.$gaHelper.getDepositValue(payload.amount),
              },
              {
                label: 'cash_fail',
                value: Vue.prototype.$gaHelper.getDepositValue(payload.amount),
              },
          );
        })
        .finally(() => {
          commit('depositStore/setPostDepositLoading', false, { root: true });
        });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
